import Ingredient, { IngredientInterface } from './ingredient';
import ProductOption, { ProductOptionInterface } from './product-option';

export enum StepType {
    INGREDIENTS = 'ingredients',
    OPTIONS = 'options'
};

export interface StepInterface {
    id: number;
    name: string;
    label: string;
    help: string;
    position: number;
    type: StepType;
    is_customisable: boolean;
    min_items: number;
    max_items: number;
    ingredients: IngredientInterface[];
    product_options: ProductOptionInterface[];
};

export default class Step implements StepInterface {
    id: number;
    name: string;
    label: string;
    help: string;
    position: number;
    type: StepType;
    is_customisable: boolean;
    min_items: number;
    max_items: number;
    ingredients: Ingredient[];
    product_options: ProductOption[];

    constructor(step: StepInterface) {
        this.id = step.id;
        this.name = step.name;
        this.label = step.label;
        this.help = step.help;
        this.position = step.position;
        this.type = step.type;
        this.is_customisable = step.is_customisable;
        this.min_items = step.min_items;
        this.max_items = step.max_items;
        this.ingredients = Ingredient.createBatch(step.ingredients);
        this.product_options = ProductOption.createBatch(step.product_options);
    }

    public static createBatch(steps: StepInterface[]): Step[] {
        let stepInstances = [];
        for (let index = 0; index < steps.length; index++) {
            stepInstances.push(new Step(steps[index]));
        }
        return stepInstances;
    }
}
